<template>
    <button
        :class="[
            'group rounded-full shadow hover:shadow-inner transition duration-button-hover ease-in',
            colorClass,
            widthClass,
            heightClass,
            paddingClass,
        ]"
    >
        <PhArrowLeft
            v-if="direction == 'left'"
            class="transform group-hover:scale-95 transition duration-button-hover"
        />
        <PhArrowRight
            v-if="direction == 'right'"
            class="transform group-hover:scale-95 transition duration-button-hover"
        />
    </button>
</template>

<script>
import { PhArrowLeft, PhArrowRight } from '@phosphor-icons/vue'

export default {
    name: 'ArrowButton',

    components: {
        PhArrowLeft,
        PhArrowRight,
    },

    props: {
        direction: {
            type: String,
            default: 'right',
            validator: (value) => ['left', 'right'].includes(value),
        },

        colorClass: {
            type: String,
            default: 'bg-primary text-primary-text hover:bg-primary-hover',
        },

        widthClass: {
            type: String,
            default: 'w-16',
        },

        heightClass: {
            type: String,
            default: 'h-16',
        },
        paddingClass: {
            type: String,
            default: 'p-0',
        },
    },
}
</script>
